const AboutClientData = [
  {
    listImage: "img",
    listTitleHead: "About Me",
    listTitleDesc: "updated 3 Mar, 2023",
  },
]

export default AboutClientData
